__turbopack_context__.v({
  "chevron": "uNjfVW_chevron",
  "label": "uNjfVW_label",
  "selectorGroup": "uNjfVW_selectorGroup",
  "trigger": "uNjfVW_trigger",
  "triggerIcon": "uNjfVW_triggerIcon",
  "triggerText": "uNjfVW_triggerText",
  "wrap": "uNjfVW_wrap",
});
